import { Flex } from "@chakra-ui/react";

import { formatSecurities } from "@equidefi/shared";

import { USDInput } from "./USDInput";
import { SharesInput } from "./SharesInput";

export default function CommonStockForm({
  values,
  handleBlur,
  setValues,
  errors,
  touched,
  offering,
  inputMode = "USD",
}) {
  const unitPrice = Number(offering?.unit_price);
  const securitiesLabel = formatSecurities({ offering }).label;
  const hideSecurityLabel = !!offering?.settings?.hide_security_label;
  const mode = hideSecurityLabel ? "USD" : inputMode;

  let InputComponent;
  if (mode === "USD") {
    InputComponent = USDInput;
  } else {
    InputComponent = SharesInput;
  }

  return (
    <Flex direction="column">
      <InputComponent
        values={values}
        errors={errors}
        touched={touched}
        handleBlur={handleBlur}
        setValues={setValues}
        unitPrice={unitPrice}
        securitiesLabel={securitiesLabel}
      />
    </Flex>
  );
}
